import { render } from "./WebsiteConfigurator.vue?vue&type=template&id=5f3442c8&ts=true"
import script from "./WebsiteConfigurator.vue?vue&type=script&lang=ts"
export * from "./WebsiteConfigurator.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__